import ProjectsList from "../components/ProjectsList";

const HomePage = () => {
  return (
    <ProjectsList />
  );
};

export default HomePage;
